import { Component, OnInit } from '@angular/core';
import { MetaService } from '../meta.service';

@Component({
  selector: 'app-fedramp',
  templateUrl: './fedramp.component.html',
  styleUrls: ['./fedramp.component.css']
})
export class FedrampComponent implements OnInit {

  constructor(private mds: MetaService) { }

  ngOnInit(): void {
    //SEO Optimization
    var strTitle = 'RegScale - Accelerating FedRAMP';
    var description = 'RegScale is designed to leverage OSCAL and automation to help customers accelerate their FedRAMP accreditations';
    var keywords = 'RegScale, FedRAMP, OSCAL, cost reduction, acceleration, automation';
    this.mds.updateTags(strTitle, keywords, description);
  }
}
